var map = {
	"./WhatsApp Image 2025-11-17 at 17.58.06.jpeg": 2453,
	"./WhatsApp Image 2025-11-17 at 17.58.44 (1).jpeg": 3845,
	"./WhatsApp Image 2025-11-17 at 17.58.44 (2).jpeg": 3658,
	"./WhatsApp Image 2025-11-17 at 17.58.44.jpeg": 2735,
	"./WhatsApp Image 2025-11-17 at 17.58.45.jpeg": 2248,
	"./malaysia/m1.jpeg": 3447,
	"./malaysia/m10.jpeg": 33,
	"./malaysia/m3.jpeg": 4689,
	"./malaysia/m3a-imed-2026-award-ceremony.jpeg": 3804,
	"./malaysia/m4.jpeg": 7092,
	"./malaysia/m5.jpeg": 9835,
	"./malaysia/m6.jpeg": 8526,
	"./malaysia/m7.jpeg": 437,
	"./malaysia/m8.jpeg": 3096,
	"./malaysia/m9.jpeg": 991,
	"./p1.jpg": 8739,
	"./p2.jpg": 2676,
	"./p3.jpg": 833,
	"./p4.jpg": 5602
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1858;